module.exports = __webpack_public_path__ + "img/onlineCustomerService.fdfac45f.png";